module.exports = __webpack_public_path__ + "img/app_journey.1caee48c.jpg";